export default {
      id: "arrow-right-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#arrow-right-usage",
      toString: function () {
        return this.url;
      }
    }